export default __webpack_public_path__ + "static/media/logo.e0e36093.png";